import { useState } from 'react';

import { IManufacturer } from 'partsOld/types';

import AssignManufacturerModalView from './AssignManufacturerModalView';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onAssignManufacturer: (selectedItems: any, manufacturer: IManufacturer) => Promise<void>;
  selectedItems;
  filters;
}

const AssignManufacturerModal = ({
  isOpen,
  onClose,
  filters,
  onAssignManufacturer,
  selectedItems,
}: IProps) => {
  const [manufacturer, setManufacturer] = useState<IManufacturer>();

  const onChangeManufacturer = (value: IManufacturer) => setManufacturer(value);

  return (
    <AssignManufacturerModalView
      isOpen={isOpen}
      onClose={onClose}
      manufacturer={manufacturer}
      onChangeManufacturer={onChangeManufacturer}
      filters={filters}
      onAssignManufacturer={onAssignManufacturer}
      selectedItems={selectedItems}
    />
  );
};

export default AssignManufacturerModal;
